import React, { useState } from 'react';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import PopperPortal from '../PopperPortal';
import { setRefs } from '../../../utils/refHelpers';
import { useBasePopper } from '../hooks/useBasePopper';
var PopperPositionedPopover = React.forwardRef(function (_a, innerRef) {
    var offsetModifier = _a.offsetModifier, allowFlip = _a.allowFlip, disablePlacementModifier = _a.disablePlacementModifier, className = _a.className, portalClassName = _a.portalClassName, placement = _a.placement, secondaryPlacement = _a.secondaryPlacement, positionFixed = _a.positionFixed, eventsEnabled = _a.eventsEnabled, referenceProp = _a.referenceElement, usePortal = _a.usePortal, children = _a.children, _b = _a.isVisible, isVisible = _b === void 0 ? true : _b, onReferenceClick = _a.onReferenceClick, onReferenceMouseEnter = _a.onReferenceMouseEnter, onReferenceMouseLeave = _a.onReferenceMouseLeave, renderPopover = _a.renderPopover, renderReference = _a.renderReference;
    var _c = useState(null), referenceElement = _c[0], setReferenceElement = _c[1];
    var positioningProps = useBasePopper({
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        eventsEnabled: eventsEnabled,
        positionFixed: positionFixed,
        offsetModifier: offsetModifier,
        allowFlip: allowFlip,
        disablePlacementModifier: disablePlacementModifier,
        referenceElement: referenceProp !== null && referenceProp !== void 0 ? referenceProp : referenceElement,
    });
    useDebugRerenders('PopperPositionedPopover', {
        offsetModifier: offsetModifier,
        allowFlip: allowFlip,
        disablePlacementModifier: disablePlacementModifier,
        className: className,
        portalClassName: portalClassName,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        referenceElement: referenceElement,
        referenceProp: referenceProp,
        usePortal: usePortal,
        children: children,
        isVisible: isVisible,
        onReferenceClick: onReferenceClick,
        onReferenceMouseEnter: onReferenceMouseEnter,
        onReferenceMouseLeave: onReferenceMouseLeave,
        renderPopover: renderPopover,
        renderReference: renderReference,
    });
    return (React.createElement(React.Fragment, null,
        !referenceProp && renderReference && (React.createElement("div", { className: className, ref: innerRef, onClick: onReferenceClick, onMouseEnter: onReferenceMouseEnter, onMouseLeave: onReferenceMouseLeave }, renderReference({ ref: setReferenceElement }))),
        !referenceProp && !renderReference && (React.createElement("div", { className: className, ref: function (node) { return setRefs([setReferenceElement, innerRef], node); }, onClick: onReferenceClick, onMouseEnter: onReferenceMouseEnter, onMouseLeave: onReferenceMouseLeave }, children)),
        isVisible &&
            (usePortal ? (React.createElement(PopperPortal, { portalClassName: portalClassName }, renderPopover(positioningProps))) : (renderPopover(positioningProps)))));
});
PopperPositionedPopover.displayName = 'PopperPositionedPopover';
export default PopperPositionedPopover;
//# sourceMappingURL=PopperPositionedPopover.js.map